import React from 'react';
import { Page } from '../Page';
import { Droplet, Eye, Brain, Info, AlertCircleIcon } from 'lucide-react';
import { SupplementCallout } from '../SupplementCallout';
export function Page7() {
  return <Page pageNumber={18} variant="light" data-id="element-1035" data-mp="1goopcdx5dt59">
      <div className="flex flex-col h-full" data-id="element-1036" data-mp="1gpznny7tq8oz">
        <div className="h-[180px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-1037" data-mp="1lmq3qljmp4ae">
          <img src="https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=1000&q=80" alt="Fresh salmon and omega-3 rich foods" className="w-full h-full object-cover" data-id="element-1038" data-mp="29cst2tw5rw5b" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-1039" data-mp="1znj2jigyqljb" />
        </div>

        <div className="mb-8 pt-4" data-id="element-1040" data-mp="24kszrkalg1hp">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1041" data-mp="24jzrgevzl3xg">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1042" data-mp="2x2wz17wtk7zh">
            Omega-3 <span className="text-tealslate" data-id="element-1043" data-mp="8po7sflhb70r">Fatty Acids</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1044" data-mp="8nl8f4yfs1jd" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-1045" data-mp="4pxb5v99twob">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1046" data-mp="igaj3xm5xbdn">
            Omega-3s are essential fats your body cannot produce on its own.
            While they are important for everyone, they play a specific and
            critical role when you are taking GLP-1 medication.
          </p>
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-1047" data-mp="nf3w7oxjf0da">
            <div className="flex items-center gap-2 mb-2" data-id="element-1048" data-mp="ngy7ebj0be46">
              <Info className="w-4 h-4 text-tealslate" data-id="element-1049" data-mp="11dk43j74ywx0" />
              <h3 className="font-bold text-[#1F1F1F] text-xs" data-id="element-1050" data-mp="wfik8w1vytkh">
                What About ALA?
              </h3>
            </div>
            <p className="text-[10px] text-[#3B3B3B] leading-[1.7]" data-id="element-1051" data-mp="3356p944cjxlk">
              ALA (found in flaxseed, chia, walnuts) converts poorly to EPA and
              DHA. ALA-only supplements are an unreliable way to meet your
              omega-3 needs.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-5 mb-8" data-id="element-1052" data-mp="1721ylqp29lcl">
          {[{
          icon: Droplet,
          title: 'Elevated Triglycerides',
          text: 'Omega-3s have a well-established lowering effect.'
        }, {
          icon: Eye,
          title: 'Dry Eyes & Skin',
          text: 'Supports retinal structure and skin barrier function.'
        }, {
          icon: Brain,
          title: 'Mental Fatigue',
          text: 'Low intake may contribute to brain fog.'
        }].map((item, i) => <div key={i} className="text-center" data-id="element-1053" data-mp="1zqh9q252njin" data-mpi={i}>
              <div className="w-12 h-12 rounded-full bg-tealslate/15 border border-tealslate/30 flex items-center justify-center mx-auto mb-3" data-id="element-1054" data-mp="1ztbwi0bk5gf8">
                <item.icon className="w-5 h-5 text-tealslate" data-id="element-1055" data-mp="28t8mc59oolbv" />
              </div>
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-1056" data-mp="3tarcmusyurqz">
                {item.title}
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-relaxed" data-id="element-1057" data-mp="3oa3i3z5j3ss0">
                {item.text}
              </p>
            </div>)}
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-1058" data-mp="3fagkzpju194r">
          <div className="bg-white border border-[#D8D8D0] p-4" data-id="element-1059" data-mp="3fc1edbueum11">
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-1060" data-mp="fvl65mcgvt34">
              Fishy Burps
            </h3>
            <p className="text-[10px] text-[#3B3B3B] leading-[1.7]" data-id="element-1061" data-mp="buswirzonm6b">
              <strong data-id="element-1062" data-mp="72rqhnt3yroq">Enteric-coated</strong> capsules dissolve in the intestine
              instead of the stomach, reducing this common side effect.
            </p>
          </div>
          <div className="bg-white border border-[#D8D8D0] p-4" data-id="element-1063" data-mp="223x4vhepyrc">
            <div className="flex items-center gap-2 mb-1" data-id="element-1064" data-mp="zkvkox0h87zn">
              <AlertCircleIcon className="w-3.5 h-3.5 text-[#C4956A]" data-id="element-1065" data-mp="us2gca8x71o3" />
              <h3 className="font-bold text-[#1F1F1F] text-xs" data-id="element-1066" data-mp="uqrh8nqf6i3b">Safety</h3>
            </div>
            <p className="text-[10px] text-[#3B3B3B] leading-[1.7]" data-id="element-1067" data-mp="effu7mmy8r87">
              Taking high doses with blood thinners may increase bleeding risk.
              Stay within <strong data-id="element-1068" data-mp="5dq2efp5nq9w">250-500 mg per day</strong>.
            </p>
          </div>
        </div>

        <SupplementCallout title="Fish Oil" description="If you do not eat fatty fish 2-3 times per week, a fish oil supplement providing 250-500mg combined EPA and DHA is recommended." data-id="element-1069" data-mp="acj99p9xsj13" />
      </div>
    </Page>;
}